import { _get, _post } from "../../../Api";
import { toast } from "react-toastify";
import { setMerchant } from "../../../store/CloudActions";
import cloudStore from "../../../store/CloudStore";

export function getOppMasterMerchants() {
  return _get("/nova/v2/opp_master_merchants")
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}

export function getOppMerchants(opp_master_merchant_id, page) {
  return _get("/nova/v2/opp_merchants?page=" + page + "&opp_master_merchant_id=" + opp_master_merchant_id)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}

export function updateOppMerchant(oppMerchant, newData, oldValues) {
  return updateOppMerchants([oppMerchant], [newData], [oldValues]).then((oppMerchants) => {
    let merchant = cloudStore.merchant;
    merchant.opp_merchant = oppMerchants[0];
    setMerchant(merchant);
    return Promise.resolve(oppMerchants[0]);
  });
}

export function updateOppMerchants(oppMerchants, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in oppMerchants) {
    data.push({
      oppMerchantId: oppMerchants[i]?.id,
      opp_master_merchant_id: oppMerchants[i]?.opp_master_merchant_id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/opp_merchants/update", data)
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}

export function updateOppInvoiceMerchants(oppMasterMerchantId, oppInvoiceMerchants, newData) {
  let data = [];
  for (let i in oppInvoiceMerchants) {
    data.push({
      oppInvoiceMerchantId: oppInvoiceMerchants[i]?.id,
      ...newData[i],
    });
  }
  return _post(`/nova/v2/opp_master_merchants/${oppMasterMerchantId}/opp_invoice_merchants`, data)
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}

export function getOppSettlements(opp_master_merchant_id, oppMerchantUid, page) {
  return _get(
    `/nova/v2/opp_master_merchants/${opp_master_merchant_id}/opp_merchants/${oppMerchantUid}/settlements?page=` + page
  )
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}

export function getOppSettlement(opp_master_merchant_id, oppMerchantUid, settlementUid, page) {
  return _get(
    `/nova/v2/opp_master_merchants/${opp_master_merchant_id}/opp_merchants/${oppMerchantUid}/settlements/${settlementUid}?page=` +
      page
  )
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}

export function getOppInvoiceMerchants(opp_master_merchant_id, page) {
  return _get(`/nova/v2/opp_master_merchants/${opp_master_merchant_id}/opp_invoice_merchants?page=` + page)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}

export function createOppInvoiceMerchants(opp_master_merchant_id, data) {
  return _post(`/nova/v2/opp_master_merchants/${opp_master_merchant_id}/opp_invoice_merchants`, data)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}

export function createWefactMasterInvoices(opp_master_merchant_id, oppInvoiceMerchantIds, period) {
  return _post(`/nova/v2/opp_master_merchants/${opp_master_merchant_id}/invoice`, { oppInvoiceMerchantIds, period })
    .then((res) => {
      toast.success("Invoiced", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}

export function getWefactDebtor(opp_master_merchant_id, cocNumber, page) {
  return _get(
    `/nova/v2/opp_master_merchants/${opp_master_merchant_id}/wefact_debtor?coc_number=${cocNumber}&page=` + page
  )
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}
